/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper", {});

// swiper change event
productImages.on('slideChange', function () {
    // update thumbnail
    document.querySelector(".productThumbnail.active").classList.remove("active");
    document.querySelectorAll(".productThumbnail")[productImages.activeIndex].classList.add("active");
});

// thumbnail
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // change active slide
        productImages.slideTo(parseInt(this.getAttribute("index")) - 1);
        // update active class
        document.querySelector(".productThumbnail.active").classList.remove("active");
        this.classList.add("active");
    });
});

/**************
 * QUick Scroll
 */

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("#productLearn") && document.querySelector(".pack")) {
        document.querySelector("#productLearn").classList.add("active");
        document.querySelector("#productLearn").addEventListener("click", function () {
            window.scrollTo({
                behavior: "smooth",
                top: document.querySelector(".pack.active").offsetTop - 100
            })
        })
    }
});

/***************
 * Product Quantity
 *******************/

let quantity = 1;

if (document.querySelector("#productQuantity")) {
// minus
    document.querySelector("#productQuantityMinus").addEventListener("click", function () {
        if (quantity > 1) {
            quantity--;
        }
        document.querySelector("#productQuantityValue").value = quantity;
    });

// plus
    document.querySelector("#productQuantityPlus").addEventListener("click", function () {
        if (quantity < 100) {
            quantity++;
        }
        document.querySelector("#productQuantityValue").value = quantity;
    });
}

/**************
 Product ATC
 ***************/

// function to determine variant id
function getFormData() {
    let formData = {
        quantity: quantity
    }

    // pint club
    if (template == "product.pint-club") {

        // determine flavor
        let flavor = document.querySelector("#productFlavor").value;

        // get product (which is based on length)
        let product = JSON.parse(document.querySelector(".productCheckboxInput:checked").getAttribute("product"));

        // determine flavor (variant)
        for (let i = 0; i < product.variants.length; i++) {
            if (product.variants[i].option1 == flavor) {
                formData.id = product.variants[i].id;
            }
        }

        // add selling plan
        formData.selling_plan = product.selling_plan_groups[0].selling_plans[0].id;

    }
    // best seller
    else {

        formData.id = product.variants[0].id;

        // check if subscription is selected
        if (document.querySelector(`[value="subscription"]`).checked) {
            // determine selling plan via properties
            formData.selling_plan = parseInt(document.querySelector("#productFrequency").value)
        }

    }

    return formData;
}


document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productATC").classList.add("loading");

    let formData = getFormData();

    // GA4 add_to_cart
    dataLayer.push({ecommerce: null});
    dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            subscription_included: formData.selling_plan !== undefined,
            value: activeVariant.price * (formData.selling_plan !== undefined ? 0.8 : 1) * quantity / 100,
            currency: Shopify.currency.active,
            items: [{
                item_id: product.id,
                item_name: product.title,
                item_variant: activeVariant.title,
                price: activeVariant.price * (formData.selling_plan !== undefined ? 0.8 : 1) / 100,
                quantity: quantity,
                subscription_item: formData.selling_plan !== undefined,
            }]
        }
    });

    // add product
    await addProduct(formData);

    // open cart
    document.querySelector(".js-drawer-open-right").click();

    // remove loading animation
    setTimeout(function () {
        document.querySelector("#productATC").classList.remove("loading");
    }, 500);
});


/**************
 Product Tabs
 ***************/

document.querySelectorAll(".productTab").forEach(function (element, index) {
    element.addEventListener("click", function () {
        //is this current one open, if so close
        if (this.classList.contains("active")) {
            this.classList.remove("active");
            this.nextElementSibling.removeAttribute("style");
        } else {
            this.classList.add("active");
            this.nextElementSibling.style.height = `${this.nextElementSibling.scrollHeight}px `;
        }
    });
});

/********************** Price change pint club ******************/

if (template == "product.pint-club") {

    document.querySelectorAll(`[name="purchase"]`).forEach(function (element) {
        element.addEventListener("change", function () {
            let activeEl = document.querySelector(`[name="purchase"]:checked`);
            let price = activeEl.getAttribute("price");
            let compare = activeEl.getAttribute("compare");

            if (price && compare) {
                document.querySelector("#productPriceTotal").innerHTML = `<s aria-label="compare price">${compare}</s><span aria-label="purchase price">${price}</span>`;
            } else {
                document.querySelector("#productPriceTotal").innerHTML = `<span aria-label="purchase price">${price}</span>`;
            }
        });
    })

    document.querySelector("#productFlavor").addEventListener("change", function () {
        document.querySelector(".pack.active").classList.remove("active");
        (document.querySelectorAll(`.pack`)[this.selectedIndex]).classList.add("active");
    });

}

/**************************** Best Sellers *******************/
else {
    // get prices
    let onetimePrice = document.querySelector("#productPriceTotal").getAttribute("onetime");
    let subscriptionPrice = document.querySelector("#productPriceTotal").getAttribute("subscription");

    // One Time Purchase
    document.querySelectorAll(`[name="purchase"]`).forEach(function (element) {
        element.addEventListener("change", function () {
            let activeEl = document.querySelector(`[name="purchase"]:checked`);
            if (activeEl.value == "subscription") {
                document.querySelector("#productPriceSavings").classList.add("active");
                document.querySelector("#productPriceTotal").innerHTML = `<s aria-label="compare price">${onetimePrice}</s><span aria-label="purchase price">${subscriptionPrice}</span>`;
            } else {
                document.querySelector("#productPriceTotal").innerHTML = `<span aria-label="purchase price">${onetimePrice}</span>`;
                document.querySelector("#productPriceSavings").classList.remove("active");
            }

        });
    })
}